import { render } from "./StrengthCharacteristics.vue?vue&type=template&id=078a4838"
import script from "./StrengthCharacteristics.vue?vue&type=script&lang=js"
export * from "./StrengthCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script